module.exports = __webpack_public_path__ + "img/scan.04df09f5.png";